(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[2624],{

/***/ 12624:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
__webpack_require__.r(__webpack_exports__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(11527);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(50959);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(26538);
/* harmony import */ var next_image__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(next_image__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var _VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(57210);
/* harmony import */ var _VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var react_awesome_reveal__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(56399);
/* harmony import */ var react_scroll__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(99585);
/* harmony import */ var _Button__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(32033);
/* harmony import */ var _Typography__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(39181);








// Skip autoplaying the hero video on mobile viewports or when the user has
// opted into reduced data / reduced motion - these make the ~1MB video an
// expensive, unwanted download. Deliberately NOT gating on
// connection.effectiveType: Chrome's Network Information API estimates it
// from recent RTT/bandwidth samples and frequently misreports fast
// connections as "3g" (confirmed - it silently disabled autoplay for a
// perfectly good connection), so it's too unreliable to use here.
var shouldAutoplayVideo = function() {
    if (false) {}
    var connection = navigator.connection || navigator.mozConnection || navigator.webkitConnection;
    if (connection === null || connection === void 0 ? void 0 : connection.saveData) return false;
    if (window.matchMedia("(prefers-reduced-motion: reduce)").matches) return false;
    if (window.matchMedia("(max-width: 767px)").matches) return false;
    return true;
};
var VideoSection = function(param) {
    var data = param.data;
    var ref;
    var heroComponents = data === null || data === void 0 ? void 0 : (ref = data.components) === null || ref === void 0 ? void 0 : ref.find(function(comp) {
        return comp.name === "hero_section";
    });
    var videoRef = (0,react__WEBPACK_IMPORTED_MODULE_1__.useRef)(null);
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_1__.useState)(false), autoplay = ref1[0], setAutoplay = ref1[1];
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        setAutoplay(shouldAutoplayVideo());
    }, []);
    (0,react__WEBPACK_IMPORTED_MODULE_1__.useEffect)(function() {
        if (autoplay) {
            var ref;
            (ref = videoRef.current) === null || ref === void 0 ? void 0 : ref.play().catch(function() {
            // Autoplay can still be blocked by the browser; the poster image
            // stays visible in that case, so no fallback is needed here.
            });
        }
    }, [
        autoplay
    ]);
    var handleScroll = function() {
        react_scroll__WEBPACK_IMPORTED_MODULE_3__/* .scroller.scrollTo */ .OK.scrollTo("product", {
            duration: 200,
            delay: 0,
            smooth: "easeInOutCubic",
            offset: -90
        });
    };
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().pageWrapper),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().heroSection),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().videoBackground),
                    children: [
                        autoplay ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("video", {
                            ref: videoRef,
                            muted: true,
                            loop: true,
                            playsInline: true,
                            preload: "none",
                            poster: "/hero-poster.jpg",
                            className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().video),
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                    src: "/bannervideo.webm",
                                    type: "video/webm"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("source", {
                                    src: "/bannervideo.mp4",
                                    type: "video/mp4"
                                })
                            ]
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)((next_image__WEBPACK_IMPORTED_MODULE_2___default()), {
                            src: "/hero-poster.jpg",
                            alt: "",
                            "aria-hidden": "true",
                            layout: "fill",
                            objectFit: "cover",
                            className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().video),
                            priority: true
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                            className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().overlay)
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                    className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().content),
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_7__/* .Fade */ .pT, {
                            triggerOnce: true,
                            duration: 800,
                            delay: 200,
                            children: [
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Typography__WEBPACK_IMPORTED_MODULE_5__/* .Typography */ .ZT, {
                                    variant: "display-2xl",
                                    as: "h1",
                                    style: {
                                        position: "absolute",
                                        left: "-9999px",
                                        visibility: "hidden"
                                    },
                                    children: "Video Plugin Development for Adobe Premiere & DaVinci Resolve"
                                }),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
                                    className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().heroImageWrapper),
                                    children: [
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/home-hero-lg.svg",
                                            alt: "EPEN Ltd. Video Plugin Development Solutions for Adobe Premiere and DaVinci Resolve",
                                            className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().homeHeroImageLg)
                                        }),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("img", {
                                            src: "/home-hero.svg",
                                            alt: "EPEN Ltd. Video Plugin Development Solutions for Adobe Premiere and DaVinci Resolve",
                                            className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().homeHeroImage)
                                        })
                                    ]
                                })
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(react_awesome_reveal__WEBPACK_IMPORTED_MODULE_7__/* .Fade */ .pT, {
                            triggerOnce: true,
                            duration: 800,
                            delay: 400,
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
                                className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().ctaButton),
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_Button__WEBPACK_IMPORTED_MODULE_4__/* .Button */ .z, {
                                    size: "lg",
                                    onClick: handleScroll,
                                    className: (_VideoSection_module_scss__WEBPACK_IMPORTED_MODULE_6___default().productsButton),
                                    icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("svg", {
                                        width: "20",
                                        height: "20",
                                        viewBox: "0 0 20 20",
                                        fill: "none",
                                        xmlns: "http://www.w3.org/2000/svg",
                                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("path", {
                                            d: "M5.83398 10.8333L10.0007 15L14.1673 10.8333M5.83398 5L10.0007 9.16667L14.1673 5",
                                            stroke: "#D6BBFB",
                                            strokeWidth: "1.66667",
                                            strokeLinecap: "round",
                                            strokeLinejoin: "round"
                                        })
                                    }),
                                    iconPosition: "both",
                                    children: "Products"
                                })
                            })
                        })
                    ]
                })
            ]
        })
    });
};
/* harmony default export */ __webpack_exports__["default"] = (VideoSection);


/***/ }),

/***/ 57210:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"pageWrapper":"VideoSection_pageWrapper__nCAPh","heroSection":"VideoSection_heroSection__oHJ2q","videoBackground":"VideoSection_videoBackground__aEgz9","video":"VideoSection_video__33Oql","overlay":"VideoSection_overlay__6cxYf","content":"VideoSection_content__m_ww_","homeHeroImageLg":"VideoSection_homeHeroImageLg__MI3lQ","homeHeroImage":"VideoSection_homeHeroImage__S33w9","heroImageWrapper":"VideoSection_heroImageWrapper__cp_MQ","heroSubtitle":"VideoSection_heroSubtitle__s_v9t","ctaButton":"VideoSection_ctaButton__U1uX4"};

/***/ })

}]);